import { call, delay, put, takeLatest } from 'redux-saga/effects';
import { ISagaFunc } from 'services/actionConfigs';
import apis from './apis';
import { actions } from './slice';
import { TimeFilter } from './types';


const getSummary: ISagaFunc<{endDate: string, startDate: string}> = function* ({payload}) {
  yield delay(200);
  try {
    const response = yield call(apis.report.getSummary, payload);
        
    yield put(actions.api.report.getSummary.success(response.data.data));
  } catch (error: any) {
    yield put(
        actions.api.report.getSummary.fail(
        error.response?.data?.message || 'Failed to fetch income report'
      )
    );
  } finally {
  }
};

const getCashDeposit: ISagaFunc<{endDate: string, startDate: string}> = function* ({payload}) {
  yield delay(200);
  try {
    const response = yield call(apis.report.getCashDeposit, payload);
        
    yield put(actions.api.report.getCashDeposit.success(response.data.data));
  } catch (error: any) {
    yield put(
        actions.api.report.getCashDeposit.fail(
        error.response?.data?.message || 'Failed to fetch cash deposit report'
      )
    );
  } finally {
  }
};

const getPaymentType: ISagaFunc<{endDate: string, startDate: string}> = function* ({payload}) {
  yield delay(200);
  try {
    const response = yield call(apis.report.getPaymentType, payload);
        
    yield put(actions.api.report.getPaymentType.success(response.data.data));
  } catch (error: any) {
    yield put(
        actions.api.report.getPaymentType.fail(
        error.response?.data?.message || 'Failed to fetch payment type report'
      )
    );
  } finally {
  }
};

const getSummaryChart: ISagaFunc<{type: TimeFilter}> = function* ({payload}) {
  yield delay(200);
  try {
    const response = yield call(apis.report.getSummaryChart, payload);
        
    yield put(actions.api.report.getSummaryChart.success(response.data.data));
  } catch (error: any) {
    yield put(
        actions.api.report.getSummaryChart.fail(
        error.response?.data?.message || 'Failed to fetch summary chart report'
      )
    );
  } finally {
  }
};


// Watcher Saga
export default function* sagas() {
  yield takeLatest(actions.api.report.getSummary.fetch, getSummary);
  yield takeLatest(actions.api.report.getCashDeposit.fetch, getCashDeposit);
  yield takeLatest(actions.api.report.getSummaryChart.fetch, getSummaryChart);
  yield takeLatest(actions.api.report.getPaymentType.fetch, getPaymentType);
}
